import { render, staticRenderFns } from "./ActivationMailSent.vue?vue&type=template&id=566cf482&"
import script from "./ActivationMailSent.vue?vue&type=script&lang=ts&"
export * from "./ActivationMailSent.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationMailSent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports